<template>
  <FlyoutPortal @close="emit('close')">
    <template #header>
      <CHeading :level="3" class="p-6 pb-4 md:pb-6 text-primary-900">{{
        t('climate_rsk.environmental_and_climate_impact')
      }}</CHeading>
    </template>
    <template #default>
      <div class="px-6 bg-white">
        <CText variant="system-xs" class="mb-4 text-gray-800">
          {{ t('climate_rsk.climate_flyout_title') }}
        </CText>

        <section class="pb-4 mb-4 border-b border-gray-200 border-solid section">
          <CText variant="system-sm-semibold" class="pb-2 text-primary-900">{{
            t('climate_rsk.climate_impact')
          }}</CText>
          <CText variant="system-xs" class="text-gray-800">
            {{ t('climate_rsk.climate_impact_description') }}
          </CText>
          <br />
          <CText variant="system-xs" class="text-gray-800">
            {{ t('climate_rsk.climate_impact_description_2') }}
          </CText>
        </section>

        <section class="pb-4 mb-4 border-b border-gray-200 border-solid section">
          <CText variant="system-sm-semibold" class="pb-2 text-primary-900">{{ t('climate_rsk.unit') }}</CText>
          <CText variant="system-xs" class="text-gray-800">
            {{ t('climate_rsk.unit_description') }}
          </CText>
        </section>
        <section class="pb-4 mb-4 border-b border-gray-200 border-solid section">
          <CText variant="system-sm-semibold" class="pb-2 text-primary-900">{{
            t('climate_rsk.GWP_total_A1_A3')
          }}</CText>
          <CText variant="system-xs" class="text-gray-800">
            {{ t('climate_rsk.GWP_total_A1_A3_description') }}
          </CText>
        </section>
        <section class="pb-4 mb-4 border-b border-gray-200 border-solid section">
          <CText variant="system-sm-semibold" class="pb-2 text-primary-900">{{
            t('climate_rsk.GWP_biogenic_A1_A3')
          }}</CText>
          <CText variant="system-xs" class="text-gray-800">
            {{ t('climate_rsk.GWP_biogenic_A1_A3_description_part1') }}
          </CText>
          <br />
          <CText variant="system-xs" class="text-gray-800">
            {{ t('climate_rsk.GWP_biogenic_A1_A3_description_part2') }}
          </CText>
        </section>
        <section class="pb-4 mb-4 border-b border-gray-200 border-solid section">
          <CText variant="system-sm-semibold" class="pb-2 text-primary-900">{{
            t('climate_rsk.GWP_fossil_A1_A3')
          }}</CText>
          <CText variant="system-xs" class="text-gray-800">
            {{ t('climate_rsk.GWP_fossil_A1_A3_description') }}
          </CText>
          <br />
          <CText variant="system-xs" class="text-gray-800">
            {{ t('climate_rsk.GWP_fossil_A1_A3_description_2') }}
          </CText>
        </section>
        <section class="pb-4 mb-4 border-b border-gray-200 border-solid section">
          <CText variant="system-sm-semibold" class="pb-2 text-primary-900">{{
            t('climate_rsk.GWP_luluc_A1_A3')
          }}</CText>
          <CText variant="system-xs" class="text-gray-800"> {{ t('climate_rsk.GWP_luluc_A1_A3_description') }} </CText>
          <br />
          <CText variant="system-xs" class="text-gray-800">
            {{ t('climate_rsk.GWP_luluc_A1_A3_description_2') }}
          </CText>
        </section>

        <section class="pb-4 mb-4 border-b border-gray-200 border-solid section">
          <CText variant="system-sm-semibold" class="pb-2 text-primary-900">{{ t('climate_rsk.data_quality') }}</CText>
          <CText variant="system-xs" class="text-gray-800"> {{ t('climate_rsk.data_quality_description') }} </CText>
          <br />
          <CText variant="system-xs" class="text-gray-800">
            {{ t('climate_rsk.data_quality_description_2') }}
            <CLink
              href="https://www.boverket.se/sv/klimatdeklaration/om-klimatdeklaration/ordlista/"
              target="_blank"
              rel="noopener noreferrer"
              variant="primary"
              size="small"
              class="text-xs"
            >
              {{ t('climate_rsk.data_quality_description_url') }}
            </CLink></CText
          >
        </section>
      </div>
    </template>
    <template #footer>
      <div class="mx-1 mb-5">
        <CButton size="medium" class="w-full" @click="emit('close')">{{ t('close') }}</CButton>
      </div>
    </template>
  </FlyoutPortal>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';
const emit = defineEmits<{
  (e: 'close'): void;
}>();
const { t } = useI18n();
</script>
<script lang="ts">
export default defineComponent({
  name: 'ClimateInfoFlyout',
});
</script>
<style>
.section:last-child {
  border: none;
}
</style>
